import { createReducer, on } from '@ngrx/store';
import { SharedAction } from './shared.action';

export interface State {
  showLoading: boolean;
  agency: string;
  position: string;
  positionBranch: string;
}

export const initialState: State = {
  showLoading: false,
  agency: '',
  position: '',
  positionBranch: ''
};

export const reducer = createReducer<State>(
  initialState,
  on(SharedAction.setLoading, (state, { status }) => ({
    ...state,
    showLoading: status,
  })),
  on(SharedAction.setAgency, (state, { agency }) => ({
    ...state,
    agency,
  })),
  on(SharedAction.setPosition, (state, { position }) => ({
    ...state,
    position,
  })),
  on(SharedAction.setPositionBranch, (state, { positionBranch }) => ({
    ...state,
    positionBranch,
  }))
);
